import { Controller } from '@hotwired/stimulus'
import intlTelInput from 'intl-tel-input'

export default class extends Controller {
  static targets = ['input']

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      initialCountry: 'FR',
      preferredCountries: ['FR'],
      separateDialCode: true,
      formatOnDisplay: true,
      autoHideDialCode: false,
      nationalMode: false,
      loadUtils: () => import('intl-tel-input/utils'),
    })
  }

  disconnect() {
    if (this.iti) this.iti.destroy();
  }

  getNumber() {
    this.inputTarget.value = this.iti.getNumber();
  }
}
